import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=4ebea87c&scoped=true&"
import script from "./Sellers.vue?vue&type=script&lang=js&"
export * from "./Sellers.vue?vue&type=script&lang=js&"
import style0 from "./Sellers.vue?vue&type=style&index=0&id=4ebea87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebea87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
